import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
gsap.registerPlugin(SplitText)

export const animation = () => {
	homeBanner()
}

const homeBanner = () => {

	let el = document.querySelector('[data-animation="home-banner"]')

	if (!el) return

	el.style.opacity = 1

	document.fonts.ready.then(() => {

		let split = new SplitText(el, { type: 'lines', wordsClass: 'line' })

		gsap.fromTo(split.lines, {
			y: '50%',
			opacity: 0,
		}, {
			y: 0,
			opacity: 1,
			stagger: 0.2,
			duration: 1,
			delay: 0.3,
		})

	})

}

export default () => { }